import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import myRestClient from "../common/restClient";
import TranslatedText from "./TranslatedText";

export default class LockUnlockInstallation extends Component {
    state = { lock: false, error: false };

    componentDidMount() {
        this.setState({ lock: this.props.lock });
    }
    unlock = () => {
        const { resource_id } = this.props;
        const body = {
            data: {
                resource_id,
                locked: !this.state.lock
            }
        };
        myRestClient("UNLOCK", "installations", body).then(
            () => {
                this.setState({ showSnackBar: true, lock: !this.state.lock });
                window.location.reload();
            },
            () => {
                this.setState({ error: true });
            }
        );
    };

    renderSnackBar() {
        return (
            <Snackbar
                open={this.state.showSnackBar}
                autoHideDuration={6000}
                message={this.renderSnackMessage()}
                onClose={_ =>
                    this.setState({
                        error: false,
                        showSnackBar: false,
                        entity: null
                    })
                }
            />
        );
    }

    renderSnackMessage() {
        return this.state.error === false ? (
            this.state.lock ? (
                <span id="snack-message">
                    <TranslatedText
                        resource_name={`resources.installations.actions.locked`}
                    />
                </span>
            ) : (
                <span id="snack-message">
                    <TranslatedText
                        resource_name={`resources.installations.actions.unlocked`}
                    />
                </span>
            )
        ) : this.state.lock ? (
            <span id="snack-message">
                <TranslatedText
                    resource_name={`resources.installations.actions.errorUnlock`}
                />
            </span>
        ) : (
            <span id="snack-message">
                <TranslatedText
                    resource_name={`resources.installations.actions.errorLock`}
                />
            </span>
        );
    }

    render() {
        return (
            <span>
                {this.state.lock ? (
                    <Button
                        color="primary"
                        target="_blank"
                        onClick={this.unlock}
                    >
                        <TranslatedText
                            resource_name={`resources.installations.actions.unlock`}
                        />
                    </Button>
                ) : (
                    <Button
                        color="primary"
                        target="_blank"
                        onClick={this.unlock}
                    >
                        <TranslatedText
                            resource_name={`resources.installations.actions.lock`}
                        />
                    </Button>
                )}

                {this.renderSnackBar()}
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/LockUnlockInstallation.js